var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoricon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4 28L44 28M16 42H32M13.6 36H34.4C37.7603 36 39.4405 36 40.7239 35.346C41.8529 34.7708 42.7708 33.8529 43.346 32.7239C44 31.4405 44 29.7603 44 26.4V15.6C44 12.2397 44 10.5595 43.346 9.27606C42.7708 8.14708 41.8529 7.2292 40.7239 6.65396C39.4405 6 37.7603 6 34.4 6H13.6C10.2397 6 8.55953 6 7.27606 6.65396C6.14708 7.2292 5.2292 8.14708 4.65396 9.27606C4 10.5595 4 12.2397 4 15.6V26.4C4 29.7603 4 31.4405 4.65396 32.7239C5.2292 33.8529 6.14708 34.7708 7.27606 35.346C8.55953 36 10.2397 36 13.6 36Z",
    stroke: "#425976",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoricon);
export default __webpack_public_path__ + "static/media/monitor.icon.5bc0982fcfeb96f04b25b3178a773aa1.svg";
export { ForwardRef as ReactComponent };